import { ContextForm } from "cerulean";
import { TextInput } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import useRevalidateErroringField from "../hooks/useRevalidateErroringField";

type NameFieldProps = {
  field: string;
  revalidateErrorsOnBlur?: boolean;
};

const NameField = ({
  field,
  revalidateErrorsOnBlur = false,
}: NameFieldProps) => {
  const { l10n } = useLocalization();
  const formattedField = field.replace(/_/g, "-");
  const label = l10n.getString(`label-${formattedField}`);
  const revalidateErroringField = useRevalidateErroringField(field);

  return (
    <ContextForm.Field required key={field}>
      <TextInput
        field={field}
        label={label}
        onBlur={revalidateErrorsOnBlur ? revalidateErroringField : undefined}
      />
    </ContextForm.Field>
  );
};

export default NameField;
